// Import Leaflet library and point utility
import L from 'leaflet';
import { paginate } from './pagination.mjs';

// Define DOM elements that will be used
const elements = {
	map: document.querySelector(".map__map"), // Main map container
	controls: document.querySelector('.map__controls'), // Controls container
	items: document.querySelector(".map__items"), // List of locations container
};

// Object to store map markers indexed by point ID
let markers = [];

let featureGroups = [];

let isTouchDevice = 'ontouchstart' in document.documentElement;

if (elements.map) {

	// Initialize Leaflet map in the map container
	var map = L.map(elements.map, {
		scrollWheelZoom: false,
		dragging: !isTouchDevice,
		attributionControl: false,
	});

	// Add tile layer to the map
	var CartoDB_Positron = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
		subdomains: 'abcd',
		maxZoom: 16,
		attribution: false,
	}).addTo(map);

	// Create a new marker at specified coordinates
	const the_confidential = L.marker([47.615385, -122.344549], {
		icon: L.divIcon({
			className: 'map-icon map-icon--confidential',
		})
	});

	// Add the custom marker to the map
	the_confidential.addTo(map);

	// Fetch map data from server
	fetch('/neighborhood/map-data/')
		.then(response => response.json())
		.then(data => {
			handleTypes(data); // Process location types
			handlePoints(data); // Process location points
		});
}



/**
 * Creates and displays the type filter controls
 * @param {Object} data - Map data containing types
 */
function handleTypes(data) {
	createFeatureGroupLayers(data.types);
	createButtonControlsForMap(data.types);
}

function createFeatureGroupLayers(types) {
	for (let key in types) {
		let type = types[key];
		createFeatureGroupForType(type);
	}
}

function createButtonControlsForMap(types) {
	(function all_button() {
		let all_button = createButtonControlForType({
			value: "all",
			title: "All",
		});
		all_button.classList.add("active");
		elements.controls.appendChild(all_button);
	})();
	for (let key in types) {
		let type = types[key];
		let button = createButtonControlForType(type);
		elements.controls.appendChild(button);
	}
}

function createButtonControlForType(type) {
	let button = document.createElement("button");
	button.classList = `button button--${type.value}`;
	button.value = type.value;
	button.innerHTML = type.title;
	button.addEventListener("click", function (event) {
		handleItemActivation(event.target);
		handleButtonActiveStatus(event.target);
		handleLayerVisibility(type.value);
		focusMap(event);
	});
	return button;
}

function handleButtonActiveStatus(element) {
	let active = document.querySelector(".map__controls .active");
	if (active) active.classList.remove("active");
	element.classList.add("active");
}

function createFeatureGroupForType(type) {
	if (!featureGroups[type.value]) {
		featureGroups[type.value] = L.featureGroup().addTo(map);
	}
}

function handleItemActivation(element) {
	let value = element.value;
	let active_items = document.querySelectorAll(`.map__item.active`);
	active_items.forEach(ele => ele.classList.remove("active"));
	let target_selector = value == "all" ? `.map__item` : `.map__item[data-type=${value}]`;
	let target_items = document.querySelectorAll(target_selector);
	target_items.forEach(ele => ele.classList.add("active"));
	paginate();
}
function handleLayerVisibility(selectedType) {
	if (selectedType == "all") {
		let all_layer_bounds = [];
		for (let group in featureGroups) {
			map.addLayer(featureGroups[group])
			all_layer_bounds.push(featureGroups[group].getBounds());
		}
		map.fitBounds(all_layer_bounds).closePopup();
	} else {
		// hide all the layers
		for (let group in featureGroups) {
			map.removeLayer(featureGroups[group]);
		}
		let selectedGroup = featureGroups[selectedType];
		// show selected
		map.addLayer(selectedGroup);
		map.fitBounds(selectedGroup.getBounds());
	}
}

/**
 * Handles processing of map points data
 * @param {Object} data - Map data containing points
 */
function handlePoints(data) {
	makeMapMarkers(data); // Create map markers
	makeHtmlItems(data); // Create HTML list items
}

/**
 * Creates markers on the map for each location point
 * @param {Object} data - Map data containing points
 */
function makeMapMarkers(data) {
	let points = data.points;
	// Add markers for each point
	points.forEach(function (point) {

		// Create a new marker at point coordinates
		const marker = L.marker(point.coordinates, {
			icon: L.divIcon({
				className: `map-icon map-icon--${point.type}`,
				// html: "",
				// iconSize: [30, 42],
				// iconAnchor: [15, 42]
			})
		});
		marker.addTo(featureGroups[point.type]);

		// Create popup content with point details
		const popupContent = `
            <div class="map-popup">
                <h3>${point.title}</h3>
				<h6>${point.description}</h6>
				<div>${point.body}</div>
                <p class='walktime'>${point.walktime} min walk</p>
            </div>
        `;

		// Bind popup to marker
		marker.bindPopup(popupContent, {
			className: `popup--${point.type}`
		});

		// Add marker to map
		marker.addTo(map);

		// Store marker reference indexed by point ID
		markers[point.id] = marker;
	});

	// Automatically zoom map to show all markers
	let allcoordinates = points.map(point => point.coordinates);
	var bounds = L.latLngBounds(allcoordinates);
	map.fitBounds(bounds, {
		padding: [5, 5] // Padding in pixels
	});
}

/**
 * Creates HTML list of locations with click handlers
 * @param {Object} data - Map data containing points
 */
function makeHtmlItems(data) {
	// Generate HTML for each point
	elements.items.innerHTML = data.points.map(point => {
		return `
			<div class="map__item active" data-type="${point.type}">
				<h3 class="map__item__title">
					<a href="#" data-attr="${point.id}">
						${point.title}
					</a>
				</h3>
				<p class='map__item__description'>
					${point.description}
				</p>
			</div>
		`;
	}).join('')

	// Add click handlers to each location item
	document.querySelectorAll(".map__item__title a").forEach(function (element) {
		element.addEventListener("click", function (event) {
			event.preventDefault();
			let id = element.getAttribute("data-attr");
			let point = data.points.find(point => point.id == id);
			let marker = markers[id];
			// Center map on clicked location and show popup
			map.setView(point.coordinates, 15);
			marker.openPopup();
			focusMap(event);
		});
	})
	paginate();
}

function focusMap(event) {
	event.preventDefault();
	let masthead_height = document.querySelector(".masthead").offsetHeight;
	let map = document.getElementById("map");
	let target_top = map.offsetTop;
	window.scrollTo({
		top: target_top - masthead_height,
		behavior: 'smooth'
	});
}
